import React from "react";

interface FormTextAreaProps extends React.TextareaHTMLAttributes<HTMLTextAreaElement> {
    label?: string;
}

export const FormTextArea = ({ label, id, ...props }: FormTextAreaProps) => {
    return (
        <div>
            <textarea
                id={id}
                {...props}
                placeholder={label}
                className={`w-full px-4 py-3 border-b border-gray-400 focus:outline-none text-xs bg-transparent transition-colors focus:border-neutral resize-none ${props.className || ""}`}
            />
        </div>
    );
};

export default FormTextArea;
